import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-radio",
  "use": "icon-radio-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-radio\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.2 63.9c-246.3 0-447.8 201.5-447.8 447.8s201.5 447.8 447.8 447.8C757.5 959.6 959 758 959 511.7S757.5 63.9 511.2 63.9z m357.3 598.2c-19.6 46.2-47.7 87.7-83.4 123.4s-77.3 63.8-123.4 83.4c-47.7 20.3-98.3 30.6-150.4 30.6-52.1 0-102.7-10.3-150.4-30.6-46.2-19.6-87.7-47.7-123.4-83.4s-63.8-77.3-83.4-123.4c-20.3-47.7-30.6-98.3-30.6-150.4 0-52.1 10.3-102.7 30.6-150.4 19.6-46.2 47.7-87.7 83.4-123.4s77.3-63.8 123.4-83.4c47.7-20.3 98.3-30.6 150.4-30.6 52.1 0 102.7 10.3 150.4 30.6 46.2 19.6 87.7 47.7 123.4 83.4s63.8 77.3 83.4 123.4C888.7 409 899 459.6 899 511.7c0 52.1-10.3 102.7-30.5 150.4z\" fill=\"\" p-id=\"11369\" /><path d=\"M511.2 511.7m-170 0a170 170 0 1 0 340 0 170 170 0 1 0-340 0Z\" fill=\"\" p-id=\"11370\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/radio.svg
// module id = zQDs
// module chunks = 11